import React from "react";
import {Button } from "antd-mobile";
class Debug extends React.Component {
  state = {
    openid:'',
  };

  async componentDidMount() {
  let str=localStorage.getItem('openid')
  this.setState({openid:str})
  }
  constructor(props){
    super(props);
    
  }
 
  render() {
    return (
      <div className='content_sig'>
       <div dangerouslySetInnerHTML={{ __html: this.state.str}}></div>
       
        <p>openid:{this.state.openid}</p>
        <Button type='primaty' onClick={()=>{
          localStorage.clear();
        }}>清缓存</Button>

      </div>
    );
  }
}

export default Debug;
